import { BuilderContentBlocks } from "../ui/BuilderContentBlocks";
import { useEffect, useState } from "react";

export default function ComponentsPage() {
  const [content, setContent] = useState([]);

  useEffect(() => {
    console.log("[SFPB] Client-side dynamic content loaded :smiley:, begin your adventures wise one.");

    const handleMessage = (event) => {
      if (!event.data) {
        console.log("[SFPB - Success:white_check_mark:] No data received.");
        return;
      }

      console.log("[SFPB - Success:white_check_mark:] Type:", event.data.type);

      switch (event.data.type) {
        case "SET_CONTENT":
          const parsed = JSON.parse(event.data.message);
          console.log("[SFPB - Success:white_check_mark:] Message:", parsed);

          setContent(parsed);
          break;
        default:
          console.error("[SFPB - Error:rotating_light:] Unknown type:", event.data.type);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  if (!content.length)
    return (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center p-5" style={{ marginTop: 110 }}>
        <p className="m-5">No components are passed in.</p>
      </div>
    );

  return (
    <div style={{ marginTop: 110 }}>
      <BuilderContentBlocks data={content} />
    </div>
  );
}
